import * as React from 'react';

function SvgRoleContentSupervisor(props) {
  return (
    <svg viewBox="0 0 40 41" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.085 19.7c-5.502 0-9.852-4.348-9.852-9.85 0-5.5 4.35-9.85 9.852-9.85s9.851 4.35 9.851 9.85c0 5.267-4.35 9.85-9.851 9.85zm2.796 7.238c-.864 0-.924.534-.864 1.187l.775 11.688c.032.353.082.672.258.89-1.625.041-3.068.062-4.33.062h-.654c-3.102 0-8.188-.016-10.114-.235 0 0-5.949-.235-5.949-4.114 0 0-.235-5.736 3.433-9.85l.036-.045c.406-.499 4.235-4.987 10.498-4.987l7.973.294a1.51 1.51 0 00-.078.36l-.298 4.75zm18.328 1.375H23.79c-.774 0-.827.478-.774 1.062l.694 9.563c.053.584.16 1.062.933 1.062h13.714c.8 0 .88-.478.933-1.063l.694-9.562c.053-.584.027-1.063-.774-1.063zm-.56-2.338c-.08-.478-.56-.85-1.04-.85h-5.79c-.48 0-1.12-.345-1.467-.744l-.507-.637c-.32-.399-.987-.744-1.468-.744H25.63c-.48 0-.908.478-.96 1.063l-.268 2.762H38.81l-.16-.85z"
        fill="#38b2a6"
      />
    </svg>
  );
}

export default SvgRoleContentSupervisor;
